import type { UnitSequence } from "~/types/unitSequence";

export function useUnit() {
   const $apiFetch = useNuxtApp().$apiFetch as typeof $fetch;
   const { getProfileContent } = useProfile();
   const { logInfo, logError } = useDebugger();
   const { setPageTitle } = useBreadcrumbs();
   // STATE ========================
   // Pages access fields directly on `unit` (e.g. unit?.aside, unit?.title),
   // so the state ref holds the resource itself rather than a wrapper.
   const unit = useState<UnitSequence.Resource | null>("unit", () => null);

   // QUERY ========================

   const queryUnit = async (slug: string): Promise<UnitSequence.Resource> => {
      try {
         const data = await $apiFetch<UnitSequence.Resource>(`units/${slug}`);
         setUnit(data);
         setPageTitle(data.title);
         return data;
      } catch (err) {
         logError("queryUnit failed", err);
         throw err;
      }
   };
   const setUnit = (data: UnitSequence.Resource | null) => {
      unit.value = data;
   };

   const saveUnitToProfile = async (
      slug: string,
      method: "POST" | "DELETE" = "POST",
   ): Promise<{ method: "POST" | "DELETE"; data: UnitSequence.SaveResponse }> => {
      try {
         const data = await $apiFetch<UnitSequence.SaveResponse>(
            `units/${slug}/save`,
            { method },
         );
         logInfo(`Profile Unit ${method}: `, data);
         getProfileContent("units").catch(() => {}); // best-effort refresh
         return { method, data };
      } catch (err) {
         logError("saveUnitToProfile failed", err);
         throw err;
      }
   };

   // RETURN ========================
   return {
      unit,
      setUnit,
      queryUnit,
      saveUnitToProfile,
   };
}
